import React, { Component } from 'react'
import classNames from 'classnames'
import * as Request from '../../service/data-info-chart/requestsUtil'
import { PLAZA, REO, URL_SERVER } from '../../utils/constants'
import * as Formatter from '../../utils/formatters'
import * as cbu from '../../utils/checkBusinessUnit'
import * as Parse from '../../utils/parsers'

var Loader = require('react-loader')

export default class ReoPlaza extends Component {

  constructor (props) {
    super(props)
    var today = Parse.toCustomDateLastDay(this.props.date)
    this.state = {
      buId: cbu.checkBusinessUnit(this.props.bu),
      data: [],
      date: today,
      currentPage: 0,
      totaPages: 0,
      month: '',
      firstWeek: 0,
      weeks: 0,
      loaded: false
    }
  }

  componentDidMount () {
    Request.getFetch(REO + cbu.checkBusinessUnit(this.props.bu) + PLAZA + this.state.date)
      .then((json) => {
        this.setState({data: json.data, month: json.month, firstWeek: json.firstWeek, weeks: json.weeks, loaded: true})
      })
  }

  render () {

    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    })

    const cols = []
    if (this.state.data !== []) {
      for (var i = 0; i < this.state.weeks; i++) {
        cols.push(<th className={'align-middle text-center p-1'}> Semana {this.state.firstWeek + i}</th>)
      }
    }

    const rows = []

    if (this.state.data !== []) {
      this.state.data.map((category) => {

        var weeksData = category.subcategories[0].values.map((value) => {
          return <td className={'text-right'}>{Formatter.formatNumber(value.amount)}</td>
        })

        rows.push(<tr>
          <td className={'align-middle p-1'} rowSpan={category.subcategories.length}>{category.category}</td>
          <td>{category.subcategories[0].name}</td>
          {weeksData}
          <td className={'text-right'}>{Formatter.formatNumber(category.subcategories[0].total)}</td>
        </tr>)

        if (category.subcategories.length > 1) {
          for (var i = 1; i < category.subcategories.length; i++) {
            weeksData = category.subcategories[i].values.map((value) => {
              return <td className={'text-right'}>{Formatter.formatNumber(value.amount)}</td>
            })
            rows.push(<tr>
              <td>{category.subcategories[i].name}</td>
              {weeksData}
              <td className={'text-right'}>{Formatter.formatNumber(category.subcategories[i].total)}</td>
            </tr>)
          }
        }
      })
    }

    return (
      <div className={'m-1'}>
        <Loader loaded={this.state.loaded}>
          <div className='scrollx'>
            <div className='scrollx'>
              <table className={tableClass}>
                <thead className={'p-2'} style={{color: '#FFF', backgroundColor: '#78909C'}}>
                <tr style={{height: '30px'}}>
                  <th colSpan={2} className={'align-middle'}>Reporte de eventos de operación por plaza</th>
                  {cols}
                  <th className={'text-center align-middle'}>{this.state.month}</th>
                </tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
              </table>
            </div>
          </div>
        </Loader>
      </div>
    )
  }

}




// WEBPACK FOOTER //
// ./src/components/tables/reoPlaza.js